import { makeMsisdnBeautiful } from '../../../Utils';
import TEXTS from "../../../locale/texts";

export const contactsFromFileColumns = (pageSize, currentPage, lang = 'ru') =>
  [
    {
      title: '#',
      width: 40,
      key: 'index',
      render: (text, record, index) => {
        const indexZeroBase = currentPage === 1
          ? index
          : (index + (pageSize * (currentPage - 1)));
        return indexZeroBase + 1;
      }},
    {
      title: TEXTS.contactPhoneLabel[lang],
      width: 200,
      dataIndex: 'msisdn',
      render: (text) => typeof text === 'string'
          ? makeMsisdnBeautiful(text) : '—'
    },
    {
      title: TEXTS.dataParam1[lang],
      width: 200,
      dataIndex: 'param1',
      render: (text) => (typeof text === 'number' || (typeof text === 'string' && !!text)) ? text : '—'
    },
    {
      title: TEXTS.dataParam2[lang],
      width: 200,
      dataIndex: 'param2',
      render: (text) => (typeof text === 'number' || (typeof text === 'string' && !!text)) ? text : '—'
    },
    {
      title: TEXTS.dataParam3[lang],
      width: 200,
      dataIndex: 'param3',
      render: (text) => (typeof text === 'number' || (typeof text === 'string' && !!text)) ? text : '—'
    },
    {
      title: TEXTS.dataParam4[lang],
      width: 200,
      dataIndex: 'param4',
      render: (text) => (typeof text === 'number' || (typeof text === 'string' && !!text)) ? text : '—'
    }
  ];
